module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-detail-bill"
  }, [_c('navbar', {
    attrs: {
      "title": "餐企退单-明细"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollShow),
      expression: "scrollShow"
    }],
    staticClass: "common-scroll detail-scroll"
  }, [_c('p', {
    staticClass: "detail-bill-status"
  }, [_vm._v("订单号：" + _vm._s(_vm.returnDetailData.trans_bill_no) + "\n\t\t\t"), _c('span', {
    staticClass: "nav-btn",
    on: {
      "click": function($event) {
        return _vm.openBillInfo()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/nav-btn.png"),
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.returnDetailData.bill_state == 20) ? _c('span', {
    staticClass: "state-grey-font"
  }, [_vm._v("未确认")]) : _vm._e(), _vm._v(" "), (_vm.returnDetailData.bill_state == 21) ? _c('span', {
    staticClass: "state-red-font"
  }, [_vm._v("已确认")]) : _vm._e(), _vm._v(" "), (_vm.returnDetailData.bill_state == 29) ? _c('span', {
    staticClass: "state-grey-font"
  }, [_vm._v("已退回")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.billInfoShow),
      expression: "billInfoShow"
    }],
    staticClass: "bill-all-info"
  }, [_c('ul', {
    staticClass: "detail-bill-info-list"
  }, [_c('li', {
    staticClass: "detail-bill-fulllist"
  }, [_vm._v("退货企业：" + _vm._s(_vm.returnDetailData.restaurant_name))]), _vm._v(" "), _c('li', {
    staticClass: "detail-bill-fulllist"
  }, [_vm._v("退货机构：" + _vm._s(_vm.returnDetailData.from_organ_name))]), _vm._v(" "), _c('li', {
    staticClass: "detail-bill-fulllist detail-bill-remark"
  }, [_vm._v("整单备注：" + _vm._s(_vm.returnDetailData.remark))])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-bill-wrapper"
  }, [(!_vm.isZ5 && _vm.uploadImgList.length) ? _c('div', {
    staticClass: "upload-file-div"
  }, [_c('label', [_vm._v("附件资料：")]), _vm._v(" "), _c('upload-img', {
    attrs: {
      "uploadImgList": _vm.uploadImgList,
      "imgListLength": 6,
      "smallDelIco": _vm.smallDelIco,
      "billState": _vm.returnDetailData.bill_state,
      "jumpBill": true
    },
    on: {
      "attachClick": _vm.attachClick
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "detail-bill-list detail-bill-list-flex"
  }, _vm._l((_vm.returnDetails), function(returnDetail) {
    return _c('li', [_c('div', {
      staticClass: "returnDetail-title"
    }, [_vm._v(_vm._s(returnDetail.goods_name) + "(" + _vm._s(returnDetail.goods_unit) + ")")]), _vm._v(" "), _c('ul', {
      staticClass: "detail-bill-sonlist returnBill"
    }, [(returnDetail.goods_code) ? _c('li', {
      staticClass: "detail-bill-fulllist",
      staticStyle: {
        "width": "100%"
      }
    }, [_vm._v("品项编号：" + _vm._s(returnDetail.goods_code))]) : _vm._e(), _vm._v(" "), (_vm.isPesc) ? _c('li', [_vm._v("规格：" + _vm._s(returnDetail.goods_spec))]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("退货数量：" + _vm._s(_vm._f("numFixed")(returnDetail.goods_num, _vm.numScale)))]), _vm._v(" "), _c('li', [_vm._v("退货单价：" + _vm._s(_vm._f("numFixed")(returnDetail.goods_price_send, _vm.numScale)) + " 元")]), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.returnDetailData.hiddenTax),
        expression: "!returnDetailData.hiddenTax"
      }]
    }, [_vm._v("税率：" + _vm._s(returnDetail.goods_cess) + " %")]), _vm._v(" "), _c('li', [_vm._v("退货金额：" + _vm._s(_vm._f("numFixed")(returnDetail.sub_total_send, _vm.numScale)) + " 元")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (returnDetail.goods_assist_unit),
        expression: "returnDetail.goods_assist_unit"
      }]
    }, [_c('li', {
      staticClass: "detail-bill-twolist"
    }, [_vm._v("辅助单位：" + _vm._s(returnDetail.goods_assist_unit))]), _vm._v(" "), _c('li', {
      staticClass: "detail-bill-twolist"
    }, [_vm._v("退货辅助数量：" + _vm._s(_vm._f("numFixed")(returnDetail.goods_assist_num, 4)))])])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollShow),
      expression: "scrollShow"
    }],
    staticClass: "detail-bill-footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "detail-else-info"
  }, [(_vm.sumMoney) ? _c('div', [_c('p', [_vm._v("退货金额：" + _vm._s(_vm.sumMoney) + "元")]), _vm._v(" "), _c('p', [_vm._v("退货辅助数量：" + _vm._s(_vm._f("numFixed")(_vm.sumGoodsAssistNumReturn, 4)))])]) : _c('div', [_c('p', [_vm._v("退货金额：" + _vm._s(_vm._f("numFixed")(_vm.sumSubTotalSend, _vm.numScale)) + "元")]), _vm._v(" "), _c('p', [_vm._v("退货辅助数量：" + _vm._s(_vm._f("numFixed")(_vm.sumGoodsAssistNumReturn, 4)))])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-bill-info"
  }, [_c('span', {
    staticClass: "detail-bill-total-btn",
    on: {
      "click": _vm.infoExchange
    }
  }, [_vm._v("合计")])]), _vm._v(" "), (_vm.returnDetailData.bill_state == 20) ? _c('div', {
    staticClass: "detail-bill-return f-right"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.agreen(21)
      }
    }
  }, [_vm._v("同意")])]) : _vm._e(), _vm._v(" "), (_vm.returnDetailData.bill_state == 20) ? _c('div', {
    staticClass: "detail-bill-red f-right"
  }, [_c('a', {
    on: {
      "click": _vm.refuseB
    }
  }, [_vm._v("退回")])]) : _vm._e(), _vm._v(" "), (_vm.returnDetailData.bill_state == 21) ? _c('div', {
    staticClass: "detail-bill-return f-right",
    staticStyle: {
      "border-right": "solid 1px #fff"
    }
  }, [_c('a', {
    on: {
      "click": _vm.importExcel
    }
  }, [_vm._v("Excel")])]) : _vm._e()]), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), _c('tips-auto', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsauto),
      expression: "tipsauto"
    }],
    attrs: {
      "tipsFont": _vm.tipsFont
    }
  }), _vm._v(" "), _c('tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tips),
      expression: "tips"
    }],
    attrs: {
      "btnNum": _vm.btnNum,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.tipStatus
    }
  }), _vm._v(" "), _c('tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsB),
      expression: "tipsB"
    }],
    attrs: {
      "btnNum": _vm.btnNum,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.tipStatusB
    }
  }), _vm._v(" "), _c('tips-t', {
    ref: "tipsTShow",
    attrs: {
      "hasTipsFont": _vm.hasTipsFont,
      "btnFont": _vm.btnFont,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.getStatues
    }
  }), _vm._v(" "), _c('item-img', {
    ref: "itemImgRef"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-95983ac6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/DetailReturnBill.vue
// module id = 606
// module chunks = 1